import './component.scss';
import errorCodes from './fcmFunctionalErrorsWithBackButton.json';
import { stripLogNumber } from './logUtils';

export const isFeatureCheckEnabled = () => {
    const section = document.querySelector('section[data-accept-javascript]');

    if (!section) {
        return false;
    }

    const acceptJavascript = section.dataset.acceptJavascript === 'true';
    const openApiFeatureEnabled = section.dataset.openapiFeatureEnabled === 'true';

    return acceptJavascript && openApiFeatureEnabled;
};

export const isDisplayBackButton = () => {
    const detailP   = document.querySelector('.attention p.secondary') ||
        document.querySelector('.attention p');

    if (!detailP) {
        return false;
    }

    const detailText = (detailP.textContent || '').trim();
    const strippedDetailText = stripLogNumber(detailText);

    const showBackButton = errorCodes.includes(strippedDetailText);

    return showBackButton;
};

window.addEventListener('DOMContentLoaded', () => {
    if (!isFeatureCheckEnabled()) {
        return;
    }

    const showBack = isDisplayBackButton();
    document.body.dataset.displayBackButton = showBack;
    // Show/hide the back button in the DOM
    const backButton = document.querySelector('.go-back');
    if (backButton) {
        backButton.style.display = showBack ? '' : 'none';
    }
});
